import React, { PureComponent as Component } from 'react';
import { CardBody, Collapse } from 'reactstrap';
import propTypes from 'prop-types';

import SearchForm from './SearchForm';
import SortForm from './SortForm';

export default class Filters extends Component {
  render() {
    return (
      <Collapse isOpen={this.props.isOpen}>
        <CardBody className="filter-container__card-body">
          <SearchForm
            keyword={this.props.keyword}
            onInputChange={this.props.onHandleChange}
            onSubmit={this.props.onHandleSearch}
          />
          <hr />
          <SortForm
            per_page={this.props.per_page}
            sort_by={this.props.sort_by}
            sort_order={this.props.sort_order}
            category_id={this.props.category_id}
            active={this.props.active}
            categoryOptions={this.props.categoryOptions}
            onInputChange={this.props.onHandleChangeAndSubmit}
          />
        </CardBody>
      </Collapse>
    );
  }
}

Filters.propTypes = {
  keyword: propTypes.string,
  per_page: propTypes.oneOfType([propTypes.number, propTypes.string]),
  sort_by: propTypes.string,
  sort_order: propTypes.string,
  category_id: propTypes.oneOfType([propTypes.number, propTypes.string]),
  active: propTypes.string,
  categoryOptions: propTypes.array,
  isOpen: propTypes.bool.isRequired,
  onHandleChange: propTypes.func,
  onHandleChangeAndSubmit: propTypes.func,
  onHandleSearch: propTypes.func
};

Filters.defaultProps = {
  keyword: '',
  per_page: 15,
  sort_by: 'updated_at',
  sort_order: 'desc',
  category_id: '',
  active: '',
  categoryOptions: []
};
